import React, { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Calendar,
  Clock,
  User,
  MapPin,
  BookOpen,
  Coffee,
  Award,
  Microscope,
  Sparkles,
  Users,
  Search,
  Filter,
} from "lucide-react";

import mario from "../img/speakers/mario.png";
import mayar from "../img/speakers/mayar.png";
import fidel from "../img/speakers/fidel.png";
import oscar from "../img/speakers/oscar.png";
import gianluca from "../img/speakers/gianluca.jpg";

import cecilia from "../img/speakers/cecilia.png";
import robert from "../img/speakers/roberto.png";
import carlo from "../img/speakers/carlo.png";
import juan from "../img/speakers/juan.jpg";
import maria from "../img/speakers/maria.webp";
import esther from "../img/speakers/esther.jpg";
import elsa from "../img/speakers/elsa.jpg";
import patricia from "../img/speakers/patricia.jpeg";
import juan_manuel from "../img/speakers/juan_manuel.jpeg";
import maria_cristina from "../img/speakers/maria_cristina.png";
import cesar_compadre from "../img/speakers/cesar_compadre.jpeg";
import leticia_cano from "../img/speakers/leticia_cano.jpg";

import andres from "../img/speakers/andres_navarrete.png";
import yes from "../img/speakers/yeyetzib.jpeg";
import fabian from "../img/speakers/fabian_tamariz.jpeg";

const SCHEDULE_DATA = [
  {
    id: "cursos",
    label: "Cursos Pre-congreso",
    dateStr: "12 - 13 Oct",
    fullTitle: "Cursos Pre-Congreso Especializados",
    items: [
      {
        id: "c1",
        time: "Lunes 12 (08:00 - 13:00 / 15:00 - 18:00) & Martes 13 (4h Visita)",
        title:
          "Curso 1: Estudio integral de plantas medicinales: taxonomía, etnobotánica, fitoquímica y farmacología",
        type: "curso",
        location: "Universidad Veracruzana / Jardín Botánico",
        description:
          "Duración total: 12 horas repartidas en dos días. Incluye visita técnica guiada al jardín botánico.",
        speakers: [
          {
            name: "Dra. Feliza Ramón Farías",
            role: "Taxonomía (6 horas)",
            institution: "Universidad Veracruzana",
          },
          {
            name: "Dra. Leticia M. Cano Asseleith",
            role: "Etnobotánica y Farmacología (3 horas)",
            institution: "Universidad Veracruzana",
            avatar: leticia_cano,
          },
          {
            name: "Dr. Oscar A. Sánchez Aguirre",
            role: "Fitoquímica (3 horas)",
            institution: "Universidad Veracruzana",
            avatar: oscar,
          },
        ],
      },
      {
        id: "c2",
        time: "Martes 13 (08:00 - 12:00 GC-MS | 14:00 - 16:00 NMR)",
        title:
          "Curso 2: De la planta a la molécula: introducción a GC-MS y RMN en plantas aromáticas y medicinales",
        type: "curso",
        location: "Laboratorios Especializados",
        description:
          "Abordaje analítico instrumental enfocado en metabolitos secundarios, cromatografía de gases y resonancia magnética.",
        speakers: [
          {
            name: "Prof. Carlo Bicchi",
            role: "Docente GC-MS",
            institution: "Universidad de Torino (Italia)",
            avatar: carlo,
          },
          {
            name: "Dra. Sara Pekerar",
            role: "Docente NMR",
            institution: "Universidad Simón Bolívar (Venezuela)",
          },
        ],
      },
    ],
  },
  {
    id: "miercoles",
    label: "Miércoles 14",
    dateStr: "14 octubre 2026",
    fullTitle: "Día 1: Inauguración, Fitoquímica y Caracterización Química",
    items: [
      {
        id: "m-1",
        time: "08:00 – 09:30",
        title: "Inscripciones y entrega de credenciales",
        type: "inauguracion",
        speakers: [{ name: "Equipo de Secretaría" }],
      },
      {
        id: "m-2",
        time: "09:30 – 10:00",
        title: "Acto de Inauguración Oficial",
        type: "inauguracion",
        description:
          "Bienvenida por el Presidente del Congreso, palabras del Secretario de SOLAPLAMED, vídeo/remembranza en memoria de la Dra. Susana Abdo e inauguración formal por el Rector o su Delegado.",
        speakers: [{ name: "Comité Organizador, Autoridades" }],
      },
      {
        id: "m-3",
        time: "10:00 – 10:50",
        title:
          "Conferencia Magistral 1: Plant Volatiles and separation science: a never-ending story of continuous innovation",
        type: "magistral",
        moderator: "Omar Malagón Avilés  (moderador)",
        speakers: [
          {
            name: "Dr. Carlo Bicchi",
            institution: "Università degli Studi di Torino, Italia",
            avatar: carlo,
          },
        ],
      },
      {
        id: "m-4",
        time: "10:50 – 11:20",
        title:
          "Conferencia Magistral 2: Las plantas medicinales más allá de su uso tradicional",
        type: "magistral",
             moderator: "Omar Malagón Avilés  (moderador)",
        highlight: "Reconocimiento a la trayectoria en el COLAPLAMED",
        speakers: [
          {
            name: "Dra. Leticia M. Cano Asseleith",
            institution: "Universidad Veracruzana, México",
            avatar: leticia_cano,
          },
        ],
      },
      {
        id: "m-5",
        time: "11:20 – 11:40",
        title: "Coffee Break & Networking",
        type: "break",
      },
      {
        id: "m-6",
        time: "11:40 – 12:00",
        title:
          "Conferencia Magistral 3: Medicina Tradicional de los kichwas del alto Napo",
        type: "magistral",
             moderator: "Omar Malagón Avilés  (moderador)",
        highlight:
          "Reconocimiento al trabajo en investigación en Plantas Medicinales en Ecuador",
        speakers: [
          {
            name: "Dr. Omar Cruz Vacas",
            institution: "Investigador en Medicina Tradicional, Ecuador",
          },
        ],
      },
      {
        id: "m-7",
        time: "12:00 – 12:30",
        title:
          "Conferencia Magistral 4: Discovering new natural molecules in essential oils: case studies from Ecuador",
        type: "magistral",
             moderator: "Omar Malagón Avilés  (moderador)",
        speakers: [
          {
            name: "Dr. Gianluca Gilardoni",
            institution:
              "Universidad Técnica Particular de Loja (UTPL), Ecuador",
            avatar: gianluca,
          },
        ],
      },
      {
        id: "m-8",
        time: "12:30 – 12:40",
        title:
          "First chemical and enantiomeric characterization of <i> Nectandra reticulata </i> leaf essential oil and its archaeobotanical relevance to the Moche culture",
        type: "ponencia",
         moderator: "Omar Malagón Avilés  (moderador)",
        sessionTheme:
          "Fitoquímica, aceites esenciales y caracterización química (10 min c/u)",
        speakers: [{ name: "Yessenia Maldonado", country: "Ecuador" }],
      },
      {
        id: "m-9",
        time: "12:40 – 12:50",
        title:
          "<i> Gynoxys hallii</i>, <i>Gynoxys calyculisolvens</i> y <i>Gynoxys azuayensis</i>: perfil químico y enantioselectivo de tres fracciones volátiles de la biodiversidad ecuatoriana",
        type: "ponencia",
         moderator: "Omar Malagón Avilés  (moderador)",
        sessionTheme:
          "Fitoquímica, aceites esenciales y caracterización química",
        speakers: [{ name: "Stefanny Cuenca", country: "Ecuador" }],
      },
      {
        id: "m-10",
        time: "12:50 – 13:00",
         moderator: "Omar Malagón Avilés  (moderador)",
        title:
          "Cuantificación de ácido rosmarínico por HPLC-DAD y análisis multivariado de perfiles cromatográficos de extractos acuosos y alcohólicos de <i>Tiquilia paronychioides</i>",
        type: "ponencia",
        sessionTheme:
          "Fitoquímica, aceites esenciales y caracterización química",
        speakers: [{ name: "Sebastian Roldan", country: "Perú" }],
      },
      {
        id: "m-11",
        time: "13:00 – 15:00",
        title: "Foto Oficial del Congreso & Receso para Almuerzo",
        type: "break",
      },
      {
        id: "m-12",
        time: "15:00 – 15:10",
        title:
          "Análisis de componentes principales de huellas cromatográficas en extractos metanólicos de <i>Valeriana pilosa </i>y <i>Valeriana officinalis</i>",
        type: "ponencia",
        moderator: "Gianluca Gilardoni (moderador)",
        sessionTheme: "Fitoquímica analítica, extracción y control de calidad",
        speakers: [{ name: "Manuel Ascate", country: "Perú" }],
      },
      {
        id: "m-13",
        time: "15:10 – 15:20",
            moderator: "Gianluca Gilardoni (moderador)",
        title:
          "Innovación en la extracción de quinina de <i> Cinchona officinalis: </i> optimización de métodos rápidos y sostenibles mediante microondas y ultrasonido",
        type: "ponencia",
        sessionTheme: "Fitoquímica analítica, extracción y control de calidad",
        speakers: [{ name: "Natalí Solano", country: "Ecuador" }],
      },
      {
        id: "m-14",
        time: "15:20 – 15:30",
            moderator: "Gianluca Gilardoni (moderador)",
        title:
          "Verificación del etiquetado y control de calidad de aceites de <i>Cannabis sativa</i> L. del mercado informal colombiano mediante técnicas espectroscópicas/cromatográficas",
        type: "ponencia",
        sessionTheme: "Fitoquímica analítica, extracción y control de calidad",
        speakers: [{ name: "Gissel Perez", country: "Colombia" }],
      },
      {
        id: "m-15",
        time: "15:30 – 16:00",
        title:
          "Conferencia Magistral 5: Actividad espasmolítica de extractos de <i>Juglans neotropica</i> y derivados de fenilaminojuglona: Exploración mecanicística sobre el músculo liso intestinal",
        type: "magistral",
            moderator: "Gianluca Gilardoni (moderador)",
        speakers: [
          {
            name: "Dr. Roberto Ybañez",
            institution: "Universidad Nacional de Trujillo, Perú",
            avatar: robert,
          },
        ],
      },
      {
        id: "m-16",
        time: "16:00 – 16:30",
        title:
          "Conferencia Magistral 6: Análisis quimiométrico de datos de RMN e identificación de componentes por GC-MS para la detección de compuestos antiproliferativos en células de cáncer de próstata a partir de plantas medicinales de Veracruz",
        type: "magistral",
            moderator: "Gianluca Gilardoni (moderador)",
        speakers: [
          {
            name: "Dr. Oscar Sánchez Aguirre",
            institution: "Universidad Veracruzana, México",
            avatar: oscar,
          },
        ],
      },
      {
        id: "m-17",
        time: "16:30 – 17:00",
        title: "Coffee Break & Diálogo Científico",
        type: "break",
      },
      {
        id: "m-18",
        time: "17:00 – 17:30",
        title:
          "Conferencia Magistral 7: Plantas medicinales endémicas del Perú: etnomedicina, fitoquímica y aplicaciones en el sistema de salud",
        type: "magistral",
            moderator: "Gianluca Gilardoni (moderador)",
        speakers: [
          {
            name: "Dr. Mayar Luis Ganoza Yupanqui",
            institution: "Universidad Nacional de Trujillo, Perú",
            avatar: mayar,
          },
        ],
      },
      {
        id: "m-19",
        time: "17:30 – 18:00",
        title: "Presentación Técnica: Defenderm E (R)",
        type: "paralelo",
            moderator: "Gianluca Gilardoni (moderador)",
        speakers: [
          { name: "Representantes Científicos", institution: "Tocol Health" },
        ],
      },
      {
        id: "m-20",
        time: "18:00 – 19:00",
        title: "Cóctel de Bienvenida auspiciado por Defenderm E (R)",
            moderator: "Gianluca Gilardoni (moderador)",
        type: "break",
        speakers: [{ name: "Tocol Health" }],
      },
    ],
  },
  {
    id: "jueves",
    label: "Jueves 15",
    dateStr: "15 octubre 2026",
    fullTitle: "Día 2: Farmacología, Cáncer, Bioeconomía y Marco Regulatorio",
    items: [
      {
        id: "j-paralelo",
        time: "08:00 – 13:00 (Evento Paralelo)",
        title:
          "Taller: Intercambio de experiencias sobre uso y aprovechamiento sostenible de especies vegetales y otros recursos de la biodiversidad",
        type: "paralelo",
        highlight: "Proyecto BIOAMAZ",
        description:
          "Espacio organizado en el marco del Proyecto BIOAMAZ para bioemprendimientos, uso sostenible y entorno regulatorio con comunidades y autoridades.",
        speakers: [
          { name: "Comunidades, Autoridades Ambientales y Equipo BIOAMAZ" },
        ],
      },
      {
        id: "j-1",
        time: "08:00 – 08:30",
        title:
          "Conferencia Magistral 8: Horchata Lojana: etnomedicina, potencial farmacológico y consumo popular",
        type: "magistral",
        moderator: "Mgtr. James Calva (moderador)",
        speakers: [
          {
            name: "Dr. Juan Carlos Romero",
            institution:
              "Universidad Técnica Particular de Loja (UTPL), Ecuador",
            avatar: juan,
          },
        ],
      },
      {
        id: "j-2",
        time: "08:30 – 09:00",
        title:
          "Conferencia Magistral 9: Redes farmacológicas, composición química, validación farmacológica y cultivo de tejidos de dos plantas medicinales de México usadas en enfermedades complejas",
        type: "magistral",
         moderator: "Mgtr. James Calva (moderador)",
        speakers: [
          {
            name: "Prof. Andrés Navarrete Castro",
            institution: "Facultad de Química, UNAM, México",
            avatar: andres,
          },
        ],
      },
      {
        id: "j-3",
        time: "09:00 – 09:30",
        title:
          "Conferencia Magistral 10: <i>Duroia macrophylla </i>- the saga: phytochemistry, plant tissue culture and endophytic fungi to obtain antitumor and antituberculosis alkaloids and triterpenes",
        type: "magistral",
         moderator: "Mgtr. James Calva (moderador)",
        speakers: [
          {
            name: "Dra. Cecilia Verónica Nunez",
            institution:
              "Instituto Nacional de Pesquisas da Amazônia (INPA), Brasil",
            avatar: cecilia,
          },
        ],
      },
      {
        id: "j-4",
        time: "09:30 – 09:40",
        title:
          "Potencial citotoxicidad in silico/in vitro de extractos etanólicos de corteza de mangle rojo (<i>Rhizophora mangle</i> L.) contra cáncer de colon",
        type: "ponencia",
         moderator: "Mgtr. James Calva (moderador)",
        sessionTheme: "Potencial antineoplásico y protección celular",
        speakers: [{ name: "Sebastian Oñate", country: "Colombia" }],
      },
      {
        id: "j-5",
        time: "09:40 – 09:50",
        title:
          "Explorando el potencial antioxidante de <i>Tragia volubilis </i>L.: mitigando los efectos quimioterapéuticos de la doxorrubicina en células tumorales",
        type: "ponencia",
         moderator: "Mgtr. James Calva (moderador)",
        sessionTheme: "Potencial antineoplásico y protección celular",
        speakers: [{ name: "José Coronel", country: "Ecuador" }],
      },
      {
        id: "j-6",
        time: "09:50 – 10:00",
        title:
          "Bioprospección de plantas sudamericanas con potencial antineoplásico en cáncer de mama: integración etnofarmacológica y preclínica",
        type: "ponencia",
         moderator: "Mgtr. James Calva (moderador)",
        sessionTheme: "Potencial antineoplásico y protección celular",
        
        speakers: [
          {
            name: "Natalia Bailon-Moscoso",
            country: "Ecuador",
            avatar:
              "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1103225643_low.jpg",
          },
        ],
      },
      {
        id: "j-7",
        time: "10:00 – 11:00",
        title: "Primera Sesión de Pósteres Científicos & Coffee Break",
        type: "break",
      },
      {
        id: "j-8",
        time: "11:00 – 11:30",
        title:
          "Conferencia Magistral 11: Monitoreo fenológico-bioquímico para el escalamiento agroindustrial rural de frutales nutracéuticos de páramos y bosques nublados del norte peruano",
        type: "magistral",
         moderator: "Mgtr. James Calva (moderador)",
        speakers: [
          {
            name: "Dr. Fidel Torres",
            institution:
              "Universidad Católica Sedes Sapientiae, Chulucanas - Perú",
            avatar: fidel,
          },
        ],
      },
      {
        id: "j-9",
        time: "11:30 – 12:00",
        title:
          "Conferencia Magistral 12: Tocoflexol: Liberando el potencial terapéutico de la vitamina E",
        type: "magistral",
         moderator: "Mgtr. James Calva (moderador)",
        speakers: [
          {
            name: "Dr. César Compadre",
            institution:
              "Universidad de Arkansas de Ciencias Médicas, Estados Unidos",
            avatar: cesar_compadre,
          },
        ],
      },
      {
        id: "j-10",
        time: "12:00 – 12:10",
        title:
          "Efecto cicatrizante de oleorresina de <i>Copaifera officinalis </i>, aceite de <i>Persea americana</i> y Dermicare6® en heridas cutáneas inducidas de Cavia <i>porcellus</i>",
        type: "ponencia",
          moderator: "Mgtr. Manuel Ascate (moderador)",
        speakers: [
          {
            name: "Juan Sánchez Acosta",
            institution: "Perú",
          },
        ],
      },
      {
        id: "j-11",
        time: "12:10 – 12:20",
        title:
          "Potencial mecanismo molecular antidiabético de metabolitos de <i>Tabebuia rosea </i>mediante farmacología de redes y acoplamiento molecular in silico",
        type: "ponencia",
        moderator: "Mgtr. Manuel Ascate (moderador)",
        speakers: [
          {
            name: "Henry Perez",
            institution: "El Salvador",
          },
        ],
      },
      {
        id: "j-12",
        time: "12:20 – 12:30",
        title:
          "<i>Tabernae montana heterophylla </i>y <i>Remijia peruviana </i>como fuentes prioritarias de extractos alcaloidales leishmanicidas de la Amazonía peruana",
        type: "ponencia",
        moderator: "Mgtr. Manuel Ascate (moderador)",
        speakers: [
          {
            name: "Lastenia Ruiz - Peru",
            institution: "Perú",
          },
        ],
      },
      {
        id: "j-13",
        time: "12:30 – 12:40",
        title:
          "Evaluación de las actividades ansiolítica y antidepresiva del aceite esencial de hojas de <i> Peperomia inaequalifolia</i> Ruiz & Pav.",
        type: "ponencia",
        moderator: "Mgtr. Manuel Ascate (moderador)",
        speakers: [
          {
            name: "David Salgado",
            institution: "Perú - virtual",
          },
        ],
      },
      {
        id: "j-14",
        time: "12:40 – 12:50",
        title:
          "Efecto de extractos etanólicos de <i> Mimosa pudica</i>, <i>Lippia alba </i>y de <i> Aniba canelilla</i>, sobre la sedación en ratones BALB/c",
        type: "ponencia",
        moderator: "Mgtr. Manuel Ascate (moderador)",
        speakers: [
          {
            name: "Jesús Rojas",
            institution: "Perú ",
          },
        ],
      },
      {
        id: "j-15",
        time: "12:50 – 13:00",
        title:
          "Determinación de la capacidad antioxidante de la raíz de <i> Euterpe precatoria </i>en diferente etapa de su desarrollo",
        type: "ponencia",
        moderator: "Mgtr. Manuel Ascate (moderador)",
        speakers: [
          {
            name: "Eduardo Mera",
            institution: "Ecuador",
          },
        ],
      },
      {
        id: "j-17",
        time: "13:00 – 15:00",
        title: "Receso para Almuerzo",
        type: "break",
      },
      {
        id: "j-18",
        time: "15:00 – 15:30",
        title:
          "Conferencia Magistral 13: El consorcio FAPRONAT: la Farmacopea Herbolaria del Ecuador, necesidades y perspectivas",
        type: "magistral",
        moderator: "Dra. María Elena Cazar (moderador)",
        speakers: [
          {
            name: "Dr. Fabián León Tamariz",
            institution: "Universidad de Cuenca, Ecuador",
            avatar: fabian,
          },
        ],
      },
      {
        id: "j-19",
        time: "15:30 – 16:00",
        title:
          "Conferencia Magistral 14: Del conocimiento tradicional al estándar farmacopeico: avances y perspectivas de la Farmacopea Herbolaria de los Estados Unidos Mexicano",
        type: "magistral",
            moderator: "Dra. María Elena Cazar (moderador)",
        speakers: [
          {
            name: "Dra. Yeyetzin Hernández Frias",
            institution: "Farmacopea de los Estados Unidos Mexicanos",
            avatar: yes,
          },
        ],
      },
      {
        id: "j-20",
        time: "16:00 – 16:20",
        title:
          "Conferencia Magistral 15: Bioeconomía del Ecuador, Avances y desafíos",
              moderator: "Dra. María Elena Cazar (moderador)",
        type: "magistral",
        speakers: [
          {
            name: "MgSc. Miriam Moposita",
            institution: "Ministerio de Ambiente y Energía, Ecuador",
          },
        ],
      },
      {
        id: "j-21",
        time: "16:20 – 16:40",
        title:
          "Conferencia Magistral 16: Desafios del marco legal ecuatoriano asociados al uso medicinal y comercial de la biodiversidad en Ecuador ",
        type: "magistral",
            moderator: "Dra. María Elena Cazar (moderador)",
        speakers: [
          {
            name: "Ab. María Cristina Puente",
            institution: "Biomaz project",
          },
        ],
      },

        {
        id: "j-22",
        time: "16:40 – 17:00",
        title:
          "Conferencia Magistral 17: Avances en la gestión y regulación de los conocimientos tradicionales sobre las plantas medicinales en el Ecuador",
        type: "magistral",
            moderator: "Dra. María Elena Cazar (moderador)",
        speakers: [
          {
            name: "Mgtr. Fernando Nogales",
            institution: "SENADI",
          },
        ],
      },

  {
        id: "j-23",
        time: "17:00 – 17:20",
        title: "Coffee Break",
        type: "break",
      },

      
    
    
      {
        id: "j-24",
        time: "17:20 – 18:00",
        title:
          "Encuentro de Saberes: La medicina tradicional y las plantas medicinales en Ecuador",
        type: "magistral",
        moderator: "María Cristina Puente",
        speakers: [
          {
            name: "Mireya Grega Mamallacta ",
            institution:
              "Archidona- Kichwa,Representantes de comunidades indígenas",
          },
          { name: "Miriam Moposita", institution: "MAE" },
          { name: "Fernando Nogales", institution: "SENADE" },
          {
            name: "Fabián León ",
            institution: "Farmacopea Herbolaria del Ecuador, U de Cuenca",
          },
          {
            name: "Yeyetzin Hernández",
            institution:
              "Farmacopea Herbolario de los Estados Unidos Mexicanos",
          },
        ],
      },
      {
        id: "j-25",
        time: "18:00 – 19:00",
        title: "Asamblea SOLAPLAMED",
        type: "asamblea",
        speakers: [
          {
            name: "Dr. Roberto Ybañez",
            institution: "SOLAPLAMED",
            avatar: robert,
          },
          { name: "Dr. José Luis Martínez", institution: "SOLAPLAMED" },
        ],
      },
    ],
  },
  {
    id: "viernes",
    label: "Viernes 16",
    dateStr: "16 octubre 2026",
    fullTitle: "Día 3: Conservación, Nanotecnología, Premiación y Clausura",
    items: [
      {
        id: "v-1",
        time: "08:00 – 08:30",
        title:
          "Conferencia Magistral 18: Conservar produciendo: gobernanza y valor compartido en las cadenas de palo santo e ishpingo en Ecuador",
        type: "magistral",
        moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Dr. Juan Manuel García",
            institution:
              "Universidad Técnica Particular de Loja (UTPL), Ecuador",
            avatar: juan_manuel,
          },
        ],
      },
      {
        id: "v-2",
        time: "08:30 – 09:00",
        title:
          "Conferencia Magistral 19: Convergencia entre conocimiento tradicional y evidencia científica de especies vegetales medicinales amazónicas de uso compartido en América Latina",
        type: "magistral",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Dra. Elsa Rengifo Salgado",
            institution: "MINA Consultores",
            avatar: elsa,
          },
        ],
      },




        {
        id: "v-3",
        time: "09:00 – 09:10",
        title:
          "<i>Caryodendron orinoscense</i> H. Karst (Euphorbiaceae), taxonomía, distribución y etnobotánica (un alimento multifuncional de la Amazonia Peruana) Loreto-Perú",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Bertita Loja",
            institution: "Perú",
          },
        ],
      },

           {
        id: "v-4",
        time: "09:10 – 09:20",
        title:
          "Huertos que curan: diversidad de plantas medicinales y saberes etnobotánicos en los jardines urbanos y periurbanos de Loja, Ecuador  ",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Fani Tinitana",
            institution: "Ecuador",
          },
        ],
      },

            {
        id: "v-5",
        time: "09:20 – 09:30",
        title:
          "Reforestación de Plantas Medicinales Nativas mediante Seedballs y Drones en Áreas Degradadas por Incendios y Deforestación en Cotacachi, Ecuador ",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "María López",
            institution: "Ecuador",
          },
        ],
      },
              {
        id: "v-6",
        time: "09:30 – 09:40",
        title:
          " Caracterización de cápsulas y semillas de <i>Cinchona officinalis </i>y evaluación de su germinación y enraizamiento ",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Máximo Moreira",
            institution: "Ecuador",
          },
        ],
      },

                {
        id: "v-7",
        time: "09:40 – 09:50",
        title:
          "  Aprovechamiento de los residuos de la industria vitivinícola para la obtención de compuestos bioactivos y su inclusión en productos funcionales",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Ruben Cueva",
            institution: "Perú",
          },
        ],
      },

                 {
        id: "v-8",
        time: "09:50 – 10:00",
        title:
          "  Secado por aspersión de horchata lojana: propiedades fisicoquímicas y sensoriales",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "María Guamán Bálcazar",
            institution: "Ecuador",
          },
        ],
      },
 {
        id: "v-9",
        time: "10:00 – 11:30",
        title: "Segunda Sesión de Pósteres y Coffee Break",
        type: "break",
      },

    
     
      {
        id: "v-10",
        time: "11:30 – 12:00",
        title:
          "Conferencia Magistral 20: Macronutrientes y cáncer: Papel de las plantas medicinales en el metabolismo de carbohidratos, lípidos y proteínas",
        type: "magistral",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Dra. Patricia Landázuri",
            institution: "Universidad del Quindío, Colombia",
            avatar: patricia,
          },
        ],
      },
   

      
                 {
        id: "v-11",
        time: "12:00 – 12:10",
        title:
          "  Actividad insecticida y repelente del aceite esencial de un quimiotipo colombiano de <i>Eucalyptus camaldulensis</i>  frente a <i> Sitophilus oryzae </i> ",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Yeferson Ospina",
            institution: "Colombia",
          },
        ],
      },

      
                 {
        id: "v-12",
        time: "12:10 – 12:20",
        title:
          "  Extracción verde y quimioinformática in silico del aceite esencial de <i>Matricaria chamomilla</i> L.: metabolitos insecticidas contra gorgojos de granos almacenados ",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Richard Navarro",
            institution: "Colombia",
          },
        ],
      },

                   {
        id: "v-13",
        time: "12:20 – 12:30",
        title:
          "  Perfil metabolómico y actividad larvicida de extractos etanólicos de plantas de la Región Caribe colombiana contra <i>Aedes aegypti</i> ",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Fabián Espitia",
            institution: "Colombia",
          },
        ],
      },

                   {
        id: "v-14",
        time: "12:30 – 12:40",
        title:
          " Concentración letal media de extractos acuosos de plantas medicinales usadas popularmente en medicina tradicional en Trujillo, Perú  ",
        type: "ponencia",
         moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "José Monzón",
            institution: "Perú",
          },
        ],
      },



      {
        id: "v-15",
        time: "12:40 – 12:50",
        title:
          "La briología y etnobriología en Ecuador: revisión sistemática de 1990 al 2025",
        type: "ponencia",
          moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Angel Benitez",
            country: "Ecuador",
          },
        ],
      },
      {
        id: "v-16",
        time: "12:50 – 13:00",
        title:
          "Potencial <i> in vivo </i> e <i> in silico</i> de voacangina contra larvas de <i> Aedes aegypti</i>",
        type: "ponencia",
          moderator: "Dr. Nixon Cumbicus (moderador)",
        speakers: [
          {
            name: "Julian Cabrera",
            country: "Colombia",
          },
        ],
      },
      {
        id: "v-18",
        time: "13:00 – 15:00",
        title: "Receso para Almuerzo",
        type: "break",
      },
      {
        id: "v-19",
        time: "15:00 – 15:30",
        title:
          "Conferencia Magistral 21: Nueva pandemia global: la paperización, su efecto en las plantas medicinales y 25 años de BLACPMA",
        type: "magistral",
        moderator: "Dr. Mayer Ganoza (moderador)",
        speakers: [
          {
            name: "Dr. José Luis Martínez",
            institution: "Universidad de Santiago de Chile, Chile",
          },
        ],
      },
      {
        id: "v-20",
        time: "15:30 – 16:00",
        title:
          "Conferencia Magistral 22: El Potencial de las Plantas Medicinales en Bolivia",
        type: "magistral",
         moderator: "Dr. Mayer Ganoza (moderador)",
        speakers: [
          {
            name: "Dra. Esther Ninoska Flores Quisbert",
            institution: "Universidad Mayor de San Andrés, La Paz - Bolivia",
            avatar: esther,
          },
        ],
      },
      {
        id: "v-21",
        time: "16:00 – 16:30",
        title:
          "Conferencia Magistral 23: Apósitos nano-estructurados por electrohilado: Incorporación de extractos de <i>Baccharis latifolia </i> y evaluación in vitro para su aplicación en cicatrización cutánea",
        type: "magistral",
         moderator: "Dr. Mayer Ganoza (moderador)",
        speakers: [
          {
            name: "Dra. María Elena Cazar Ramírez",
            institution: "Universidad de Cuenca, Ecuador",
            avatar: maria,
          },
        ],
      },
      {
        id: "v-22",
        time: "16:30 – 17:00",
        title: "Coffee Break & Intercambio",
        type: "break",
      },
      {
        id: "v-23",
        time: "17:00 – 17:30",
        title:
          "Conferencia Magistral 24: Estudio metabolómico de líquenes antárticos y frutos endémicos de la selva valdiviana: potencial terapéutico frente a enfermedades crónicas",
        type: "magistral",
         moderator: "Dr. Mayer Ganoza (moderador)",
        speakers: [
          {
            name: "Dr. Mario Simirgiotis",
            institution: "Universidad de Valdivia, Chile",
            avatar: mario,
          },
        ],
      },
      {
        id: "v-24",
        time: "17:30 – 18:00",
        title: "Solemne Acto de Clausura & Premiación",
        type: "inauguracion",
        description:
          "Vídeo resumen del evento, conclusiones por el Presidente de SOLAPLAMED, presentación oficial de COLAPLAMED XV en Chile, entrega de reconocimientos de pósteres y premio a la mejor ponencia oral.",
        speakers: [{ name: "Comité Organizador & Directiva SOLAPLAMED" }],
      },
    ],
  },
];

// Parser seguro para transformar etiquetas <i>...</i> en elementos JSX <em>
const renderFormattedText = (text = "") => {
  if (!text) return "";
  const parts = text.split(/<\/?i\s*>/gi);

  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <em key={index} className="italic">
        {part}
      </em>
    ) : (
      part
    ),
  );
};

// Limpieza para el buscador ignorando etiquetas HTML y tildes
const cleanText = (str = "") =>
  str
    .replace(/<[^>]*>/g, "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const TypeBadge = ({ type }) => {
  switch (type) {
    case "magistral":
      return (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-[#004270]/10 text-[#004270] border border-[#004270]/25">
          <Sparkles className="w-3.5 h-3.5" />
          Conferencia Magistral
        </span>
      );
    case "curso":
      return (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-800 border border-gray-300">
          <BookOpen className="w-3.5 h-3.5 text-[#004270]" />
          Curso Pre-Congreso
        </span>
      );
    case "ponencia":
      return (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 text-[#004270] border border-slate-300">
          <Microscope className="w-3.5 h-3.5" />
          Ponencia Oral
        </span>
      );
    case "break":
      return (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-800 border border-amber-200">
          <Coffee className="w-3.5 h-3.5 text-amber-700" />
          Receso / Café
        </span>
      );
    case "paralelo":
      return (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-[#004270] border border-[#004270]/20">
          <Users className="w-3.5 h-3.5" />
          Evento Paralelo
        </span>
      );
    case "asamblea":
      return (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-800 border border-gray-300">
          <Users className="w-3.5 h-3.5 text-[#004270]" />
          Asamblea
        </span>
      );
    default:
      return (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-700 border border-gray-300">
          <Calendar className="w-3.5 h-3.5" />
          General
        </span>
      );
  }
};

const SpeakerAvatar = ({ name, avatar }) => {
  const [imageError, setImageError] = useState(false);

  if (!avatar || imageError) {
    return (
      <div className="w-full h-full flex items-center justify-center text-[#004270] bg-gray-200 font-bold text-xs select-none">
        {name.slice(0, 2).toUpperCase()}
      </div>
    );
  }

  return (
    <img
      src={avatar}
      alt={name}
      onError={() => setImageError(true)}
      className="w-full h-full object-cover"
      loading="lazy"
    />
  );
};

export default function CongressAgenda() {
  const [selectedDayId, setSelectedDayId] = useState("miercoles");
  const [activeFilter, setActiveFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const currentDay = useMemo(() => {
    return (
      SCHEDULE_DATA.find((day) => day.id === selectedDayId) || SCHEDULE_DATA[0]
    );
  }, [selectedDayId]);

  const filteredItems = useMemo(() => {
    const query = cleanText(searchQuery.trim());

    return currentDay.items.filter((item) => {
      const matchesFilter =
        activeFilter === "all" || item.type === activeFilter;
      if (!matchesFilter) return false;
      if (!query) return true;

      const matchesTitle = cleanText(item.title).includes(query);
      const matchesSpeakers = item.speakers?.some((s) =>
        cleanText(s.name).includes(query),
      );
      const matchesTheme = item.sessionTheme
        ? cleanText(item.sessionTheme).includes(query)
        : false;
      const matchesDesc = item.description
        ? cleanText(item.description).includes(query)
        : false;
      const matchesModerator = item.moderator
        ? cleanText(item.moderator).includes(query)
        : false;

      return (
        matchesTitle ||
        matchesSpeakers ||
        matchesTheme ||
        matchesDesc ||
        matchesModerator
      );
    });
  }, [currentDay, activeFilter, searchQuery]);

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 py-12 px-4 sm:px-6 lg:px-8 mt-10">
      <div className="max-w-6xl mx-auto space-y-8">
        {/* Encabezado */}
        <header className="text-center space-y-3">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight">
            Agenda del Congreso
          </h2>
        
        </header>

        {/* Pestañas de días */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 p-1.5 bg-gray-200/80 rounded-2xl border border-gray-300 shadow-inner">
          {SCHEDULE_DATA.map((day) => {
            const isActive = day.id === selectedDayId;
            return (
              <button
                key={day.id}
                onClick={() => {
                  setSelectedDayId(day.id);
                  setActiveFilter("all");
                }}
                className={`relative px-4 py-2.5 rounded-xl font-medium text-xs sm:text-sm transition-all duration-200 flex flex-col items-center sm:items-start ${
                  isActive ? "text-white" : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {isActive && (
                  <motion.div
                    layoutId="activeTabPill"
                    className="absolute inset-0 bg-[#004270] rounded-xl shadow-md"
                    transition={{ type: "spring", stiffness: 380, damping: 30 }}
                  />
                )}
                <span className="relative z-10 font-bold">{day.label}</span>
                <span
                  className={`relative z-10 text-[11px] ${
                    isActive ? "text-gray-200" : "text-gray-500"
                  }`}
                >
                  {day.dateStr}
                </span>
              </button>
            );
          })}
        </div>

        {/* Filtros y Buscador */}
        <div className="flex flex-col md:flex-row gap-4 items-center justify-between bg-white p-4 rounded-2xl border border-gray-200 shadow-sm">
          <div className="relative w-full md:w-80">
            <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <input
              type="text"
              placeholder="Buscar por ponente o tema..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-9 pr-4 py-2 rounded-xl text-xs sm:text-sm bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#004270]/30 focus:border-[#004270]"
            />
          </div>

          <div className="flex flex-wrap items-center gap-1.5 w-full md:w-auto">
            <Filter className="w-3.5 h-3.5 text-gray-400 mr-1 hidden sm:block" />
            {[
              { id: "all", label: "Todos" },
              { id: "magistral", label: "Magistrales" },
              { id: "ponencia", label: "Ponencias" },

              { id: "break", label: "Pausas" },
            ].map((f) => (
              <button
                key={f.id}
                onClick={() => setActiveFilter(f.id)}
                className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all ${
                  activeFilter === f.id
                    ? "bg-[#004270] text-white shadow-sm"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {/* Título de la jornada */}
        <div className="border-b border-gray-200 pb-2">
          <h3 className="text-xl sm:text-2xl font-bold text-[#004270]">
            {currentDay.fullTitle}
          </h3>
        </div>

        {/* Tarjetas de eventos */}
        <div className="space-y-4">
          <AnimatePresence mode="popLayout">
            {filteredItems.length > 0 ? (
              filteredItems.map((item, index) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.98 }}
                  transition={{ duration: 0.25, delay: index * 0.03 }}
                  className={`group relative rounded-2xl p-5 sm:p-6 transition-all border ${
                    item.type === "magistral"
                      ? "bg-white border-[#004270]/40 shadow-sm hover:shadow-md ring-1 ring-[#004270]/10 border-l-4 border-l-[#004270]"
                      : item.type === "break"
                        ? "bg-amber-50/40 border-amber-200/80 shadow-none"
                        : "bg-white border-gray-200 shadow-sm hover:border-gray-300 hover:shadow-md"
                  }`}
                >
                  <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-5">
                    {/* Contenido Izquierdo */}
                    <div className="space-y-3 flex-1">
                      {/* Horario y Badges */}
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-semibold bg-gray-100 text-gray-800 border border-gray-200">
                          <Clock className="w-3.5 h-3.5 text-[#004270]" />
                          {item.time}
                        </span>

                        <TypeBadge type={item.type} />

                        {item.sessionTheme && (
                          <span className="text-xs font-medium text-gray-600 bg-gray-100 px-2.5 py-1 rounded-md border border-gray-200">
                            Sesión: {renderFormattedText(item.sessionTheme)}
                          </span>
                        )}
                      </div>

                      {/* Título de la conferencia o bloque */}
                      <h4 className="text-base sm:text-lg font-bold text-gray-900 leading-snug">
                        {renderFormattedText(item.title)}
                      </h4>

                      {/* Reconocimiento o distinción especial */}
                      {item.highlight && (
                        <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-amber-900 bg-amber-100 border border-amber-300/80 px-2.5 py-1 rounded-lg">
                          <Award className="w-3.5 h-3.5 text-amber-700" />
                          {item.highlight}
                        </div>
                      )}

                      {/* Descripción */}
                      {item.description && (
                        <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                          {renderFormattedText(item.description)}
                        </p>
                      )}

                      {/* Moderación y Lugar */}
                      <div className="flex flex-wrap gap-4 pt-1 text-xs text-gray-500">
                        {item.moderator && (
                          <span className="flex items-center gap-1 text-[#004270] font-semibold bg-[#004270]/5 px-2.5 py-0.5 rounded border border-[#004270]/15">
                            <User className="w-3.5 h-3.5 text-[#004270]" />
                            {item.moderator}
                          </span>
                        )}
                        {item.location && (
                          <span className="flex items-center gap-1 font-medium">
                            <MapPin className="w-3.5 h-3.5 text-gray-400" />
                            {item.location}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Expositores / Responsables */}
                    {item.speakers && item.speakers.length > 0 && (
                      <div className="lg:w-72 flex-shrink-0 pt-4 lg:pt-0 border-t lg:border-t-0 lg:border-l border-gray-100 lg:pl-5 space-y-3">
                        <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 block">
                          {item.type === "curso"
                            ? "Docentes a cargo"
                            : "Responsable / Expositor"}
                        </span>

                        <div className="space-y-3">
                          {item.speakers.map((speaker, sIdx) => (
                            <div key={sIdx} className="flex items-center gap-3">
                              <div className="relative w-11 h-11 rounded-full overflow-hidden border-2 border-[#004270]/30 bg-gray-100 flex-shrink-0 shadow-sm">
                                <SpeakerAvatar
                                  name={speaker.name}
                                  avatar={speaker.avatar}
                                />
                              </div>

                              <div className="min-w-0">
                                <h5 className="text-xs sm:text-sm font-semibold text-gray-900 truncate">
                                  {speaker.name}
                                </h5>
                                {speaker.role && (
                                  <p className="text-[11px] text-[#004270] font-medium">
                                    {speaker.role}
                                  </p>
                                )}
                                {(speaker.institution || speaker.country) && (
                                  <p className="text-[11px] text-gray-500 truncate">
                                    {speaker.institution || speaker.country}
                                  </p>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </motion.div>
              ))
            ) : (
              <div className="text-center py-12 bg-white rounded-2xl border border-dashed border-gray-300">
                <p className="text-gray-500 text-sm">
                  No se encontraron actividades para este filtro o búsqueda.
                </p>
              </div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
